var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 447",
    viewBox: "0 0 50.284 46"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "analytics_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h50.284v46H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#analytics_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.284 26.818c-.161.962-.291 1.931-.489 2.885a21.5 21.5 0 0 1-3.991 8.7q-.43.567-.889 1.11a1.368 1.368 0 0 1-2.139.118q-.089-.084-.175-.172-5.933-5.931-11.858-11.869a2.25 2.25 0 0 1-.584-.93 1.307 1.307 0 0 1 1.15-1.62 5 5 0 0 1 .588-.023c5.527 0 11.054.01 16.581-.013a1.725 1.725 0 0 1 1.806 1.026Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2 13.228c0 3.174.02 6.347-.015 9.521a2.44 2.44 0 0 0 .8 1.9q6.84 6.8 13.647 13.629c.359.359.713.746.593 1.273a2.03 2.03 0 0 1-.549 1.036 21.4 21.4 0 0 1-10.418 5.042A22.1 22.1 0 0 1 .457 28.156 21.4 21.4 0 0 1 4.73 10.229a21.54 21.54 0 0 1 14.59-8.357c.388-.052.78-.082 1.17-.123a1.4 1.4 0 0 1 1.7 1.516c.01 1.227 0 2.453 0 3.681v6.282Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.852 11.052V1.679c0-1.264.537-1.784 1.778-1.662A21.84 21.84 0 0 1 43.514 10.19a21.56 21.56 0 0 1 3.424 10.21 1.408 1.408 0 0 1-1.572 1.7H26.424a1.4 1.4 0 0 1-1.572-1.575q-.005-4.735 0-9.47"
  }))));
};
export default SvgAnalytics;